import React from "react";
import InfoTooltip from "../tooltips/InfoTooltip";
import {Field, useFormState} from "react-final-form";
import DropzoneField from "../fields/DropzoneField";
import {useSelector} from "react-redux";
import {limit, required} from "../../helpers/ValidateHelper";
import Error from "../fields/Error";
import TextareaField from "../fields/TextareaField";
import {optionItemFinder} from "../../helpers/OptionHelper";
import useSyncedField from "../../hooks/useSyncedField";

function OrderInstructions({showUploadFile = true}) {
    const {values: {typeOfPaper}} = useFormState();
    const {file: options, typeOfPaper: typeOfPapers} = useSelector(state => state.orderOptions.data);
    const optionItem = optionItemFinder(typeOfPaper, typeOfPapers);
    const isRevision = optionItem ? optionItem.isRevision : false;
    useSyncedField('instruction', 'string');

    return <div className="form-group">
        <div className="form-label d-flex">
            Order instructions
            <InfoTooltip>
                <p>
                    To ensure that the final paper meets your requirements, make sure your instructions are as clear and detailed as possible. This will decrease the chance of revisions in your order.
                </p>
            </InfoTooltip>
        </div>
        <div className={`order-instruction ${showUploadFile ? 'order-instruction__dropzone' : ''}`}>
            <Field
                name="instruction"
                component={TextareaField}
                placeholder="To ensure that the final paper meets your requirements, make sure your instructions are as clear and detailed as possible"
                className="order-instruction__text"
                validate={limit('Maximum {limit} characters allowed. You\'ve used {count}.', 5000)}
            />
            {showUploadFile && (
                <DropzoneField
                    name="files"
                    options={options}
                    validate={isRevision ? required('Please attach file to be edited') : undefined}
                    refreshState={false}
                />
            )}
            <Error name="instruction" />
        </div>
    </div>
}

export default OrderInstructions;